export function hideChat(payload) {
  return {
    type: "HIDE_CHAT",
    payload,
  };
}
